import callEventApi from "../../util/eventApiCaller";
import callIdApi from "../../util/idApiCaller";

export const SET_AGENT = 'SET_AGENT';
export const SET_AGENT_LIST = 'SET_AGENT_LIST';
export const SET_ACTIVE_AGENTS = 'SET_ACTIVE_AGENTS';

export function setAgent(agent) {
    return (dispatch) => {
        dispatch({
            type: SET_AGENT,
            agent: agent
        });
    };
}


export function setAgentList(agentList) {
    return (dispatch) => {
        dispatch({
            type: SET_AGENT_LIST,
            agentList: agentList
        });
    };
}

export function setActiveAgentList(activeAgents) {
    return (dispatch) => {
        dispatch({
            type: SET_ACTIVE_AGENTS,
            activeAgents: activeAgents
        });
    };
}

export function fetchAgentList () {
    return async dispatch => {
        const res = await callIdApi(`v3/agents/search?term=&team=sales`, 'GET');
        if (res.status === 'Success') {
            dispatch(setAgentList(res?.data?.agents));
        }
        return;
    };
}

export function fetchActiveAgentList () {
    return async dispatch => {
        const res = await callEventApi(`v2/agents/active-agent/list-v1`, 'POST',{});
        if (res.status === 'Success') {
            dispatch(setActiveAgentList(res?.data));
        }
        return;
    };
}

export function clearAllLocalStorageKeys () {
    return (dispatch) => {
        Object.keys(localStorage).filter(x =>
            x.startsWith('api/')).forEach(x =>
            localStorage.removeItem(x))
    }
}


